<template>
    <div>
        <section class="page-title">        
            <v-img 
                v-if="this.$vuetify.breakpoint.lg"
                height="320px"
                :src="require('@/Content/images/banner1.jpg')"
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"
                position="center top"
            >
                <div class="center">
                    <p class="label-planos">Pessoa Física</p>
                    <h1 class="the-title"><span>Soluções</span> para você</h1>
                    <p style="color:#666">Temos o plano certo para cuidar da saúde bucal de toda a família!</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
                </div>
            </v-img>
            <v-img
                v-else
                height="300"        
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"  
                position="center top"        
            >
                <div class="center">
                    <p class="label-planos" >Pessoa Física</p>
                    <h1 class="the-title"><span>Soluções</span> para você</h1>
                    <p style="color:#7593b4">Dê o primeiro passo e garanta um sorriso saudável</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
                </div>
            </v-img>
        </section>
        <section class="page-content center">
            <p class="title-label">A {{informacaoOperadora("nome")}} vem há mais de vinte e cinco anos desenvolvendo e acumulando know-how no que diz respeito à prestação de serviços na área odontológica.</p>
            <p>Nossa postura profissional foi desenvolvida através de trabalhos de pesquisa e consultoria especializada na área de odontologia, oferecendo soluções de alta qualidade em saúde bucal, visando uma organização empresarial de alto nível.</p>
            <p>Conta com uma estrutura operacional totalmente informatizada, através de softwares específicos para Convênio Odontológico, além de outros Softwares Gerenciais – o que nos permite o acompanhamento constante da nossa carteira de clientes.</p>
            <p>Disponibiliza, ainda, uma Central de Atendimento ao Cliente equipada com o que há de mais moderno em telefonia e atendimento digital; além de pessoal treinado para resolver qualquer dúvida de nossos associados.</p>
            <p>A {{informacaoOperadora("nome")}} mantém uma Rede Credenciada composta por consultórios particulares, escolhidos através de critérios rigorosos de seleção profissional, com acompanhamento e vistorias periódicas.</p>
            <p>Além disso, possui flexibilidade para ampliar a rede credenciada em qualquer região do País.</p>
            <p class="title-label">Gestão Corporativa</p>
            <p>A {{informacaoOperadora("nome")}} oferece uma estrutura para proporcionar às empresas clientes e aos associados um atendimento ágil e eficiente, com pessoal constantemente treinado e qualificado.</p>
            <p>Nossa equipe de Relacionamento Empresarial visa a otimização do tempo do RH da Empresa. Além de disponibilizar um canal de comunicação direto com os associados, disponibiliza ao RH um portal de acesso que garante mais agilidade para movimentações cadastrais; atualizações de dados e fale conosco.</p>

            <br>            
            <v-divider></v-divider>
            <br>

            <v-layout row wrap>
              <v-flex xs12 sm12 md8 lg2 style="margin:0 auto; text-align:center; ">
                <p class="title-label">Nossa Missão</p>
                <p>“Atingir e superar as expectativas dos nossos clientes, garantindo total satisfação, fazendo da Dental Plus sinônimo de excelência na prestação de serviços odontológicos.”</p>              
              </v-flex>
              <v-flex xs12 sm12 md8 lg2 style="margin:0 auto; text-align:center;">
                <p class="title-label">Nossa Visão</p>
                <p>“Administrar com sustentabilidade números expressivos, fidelizando toda nossa carteira de associados, credenciados e corretores.”</p>
              </v-flex>
              <v-flex xs12 sm12 md8 lg2 style="margin:0 auto; text-align:center;">
                <p class="title-label">Nossos Valores</p>
                <p>“Nossos colaboradores e clientes.”</p>
              </v-flex>
            </v-layout>   

            <br>            
            <v-divider></v-divider>
            <br>

            <p class="title-label" style="text-align:center;">Nossos Diferenciais</p>
            <v-layout row wrap>
              <v-flex xs12 sm12 md8 lg4 style="margin:0 auto; padding:5px; text-align:left;">
                <p class="title-label">1</p>
                <p>Uma visão moderna do atendimento por convênio, que incentiva o modelo de parceria entre os profissionais do grupo, garantindo bom retorno para todos e conseqüentemente, premiando o bom desempenho.</p>              
              </v-flex>
              <v-flex xs12 sm12 md8 lg4 style="margin:0 auto; padding:5px; text-align:left;">
                <p class="title-label">2</p>
                <p>Uma Assistência Odontológica de alto nível, avaliada por trabalhos de pesquisa constante e consultoria especializada na área de odontologia, visando desenvolver nossa postura empresarial.</p>
              </v-flex>
              <v-flex xs12 sm12 md8 lg4 style="margin:0 auto; padding:5px; text-align:left;">
                <p class="title-label">3</p>
                <p>Flexibilidade e trabalho em conjunto com nossos clientes, reconhecendo problemas específicos e ativamente nos dispondo a solucioná-los.</p>
              </v-flex>
              <v-flex xs12 sm12 md8 lg4 style="margin:0 auto; padding:5px; text-align:left;">
                <p class="title-label">4</p>
                <p>Sistemas de Controles integrados e informatizados que nos permitem pleno conhecimento da performance de nossa carteira, sempre utilizando os resultados para o aprimoramento dos nossos serviços.</p>
              </v-flex>
              <v-flex xs12 sm12 md8 lg4 style="margin:0 auto; padding:5px; text-align:left;">
                <p class="title-label">5</p>
                <p>Controle de Qualidade – Através de setor de Relacionamento ativo e constante que realizam pesquisas de satisfação com nossos usuários.</p>
              </v-flex>
              <v-flex xs12 sm12 md8 lg4 style="margin:0 auto; padding:5px; text-align:left;">
                <p class="title-label">6</p>
                <p>Os resultados são analisados e utilizados também para a modernização e melhoria dos nossos serviços.</p>
              </v-flex>
            </v-layout>  
            
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
            </div> -->
            <!-- <div>
                 <span class="icon"></span> 
                <p><strong>Ortodontia</strong> -  Documentação ortodôntica, Instalação e manutenção de aparelho metálico fixo (Verificar planos que incluem esta cobertura);</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span> 
                <p><strong>Endodontia</strong> - Tratamento de canais;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span> 
                <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
            </div>  -->

            <!-- <div>
                <span class="icon"></span>
                <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
            </div> --> 
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico), radiografia panorâmica;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Próteses</strong> - Ajuste oclusal, Coroa provisória com e sem pino, Coroa total em cerômero, Coroa total metálica, Núcleo de preenchimento, Núcleo metálico fundido, Pino pré-fabricado, Remoção de trabalhos protéticos, Restauração metálica fundida;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
            </div> -->
            <!-- <div>
                <span class="icon"></span>
                <p><strong>Implantes</strong> - Implantes Unitários, Coroa metalo-cerâmica sobre implantes, Prótese Protocolo total híbrida sobre Implantes (verificar planos que incluem esta cobertura);</p>
            </div> -->
            <!-- <div>
                <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.orale.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
            </div> -->
            <!-- <p class="title-label">Carências</p>
            <p>Não possui carências</p> -->
            <!-- <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
                <tr>
                    <th></th>
                    <th colspan="1">Carências</th>
                </tr>
                <tr class="mini-header">
                    <td>Procedimentos</td>
                    <td class="carencia">Plano Individual/Familiar</td>
                </tr>
                <tr>
                    <td>Consulta de Urgência</td>
                    <td class="carencia">24 horas</td>
                </tr>
                <tr>
                    <td>Consulta inicial, Radiologia, Prevenção</td>
                    <td class="carencia">30 dias</td>
                </tr>
                <tr>
                    <td>Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>
                    <td class="carencia">60 dia</td>
                </tr>
                <tr>
                    <td>Endodontia</td>
                    <td class="carencia">120 dias</td>
                </tr>
                <tr>
                    <td>Prótese</td>
                    <td class="carencia">180 dias</td>
                </tr>
            </table>  -->
            <div class="contrataragora"> 
                <v-fade-transition mode="out-in">    
                    <div class="exibelocalizacao" v-if="exibeLocalizacao"> 
                        <div class="planos-wrapper">
                            <p class="planos-title">Local de utilização</p>
                            <v-layout align-center>
                                <v-flex xs12 sm12>
                                    <v-card
                                        flat
                                        max-height="400px"
                                        max-width="600px"
                                        class="mx-auto localizacao"
                                        style="border: 1px solid; border-color: #1DAFFC;border-radius: 10px;"
                                    >
                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout align-center justify-center row wrap>
                                                    <v-flex xs12 sm12 lg10>
                                                        <v-select
                                                            id="comboOrgao"               
                                                            v-model="abrangenciaAgrupamento"
                                                            item-value="abrangenciaId"
                                                            item-text="agrupamento"
                                                            :items="agrupamentosUF"
                                                            label="Local de Utilização"                
                                                        ></v-select>
                                                    </v-flex>
                                                    <v-layout align-center justify-center row wrap>
                                                        <v-flex xs12 sm6 md6 lg6 >
                                                            <v-btn style="border-radius: 6px;" large dark @click="controlaExibicaoPlanos()" color="#1DAFFC">Consultar Planos</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                    <div class="exibeplanos" v-else>
                        <p class="title-label">Investimento</p>
                        <p>O investimento abaixo no plano odontológico é valor unitário da mensalidade que o Responsável Financeiro paga para a operadora.</p>
                        <div class="planos-wrapper">
                            <p class="planos-title">Região: {{this.nomeAgrupamento}}
                                <v-btn icon dark @click.prevent="exibeLocalizacao = !exibeLocalizacao" color="#1DAFFC">
                                    <v-icon style="margin-right: 0%;">cached</v-icon>
                                </v-btn>
                            </p>
                            <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
                            <v-container grid-list-md>
                                <v-layout row wrap justify-center>
                                    <v-flex v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md12 lg4>
                                        <div class="list-planos">
                                            <div class="item">
                                                <!-- <h6 class="dePara">De</h6>
                                                <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                                                <h6 class="dePara">Por</h6> -->
                                                <p class="price"><span>R$</span> {{plano.value}}<br><span>(Por pessoa)</span></p>                                                                          
                                                <p class="cobertura"><span>{{plano.area_atuacao}}</span><b>{{plano.qualificacao}}</b></p>                                               
                                                <div v-if="plano.typePayment == 'CARTAO'" style="height: 52px;" class="boleto">
                                                    <span>
                                                        <v-img 
                                                            max-height="20px"        
                                                            :src="require('@/Content/images/cartoes.png')"
                                                            max-width="60%"
                                                            style="margin-left: 50px;"
                                                        />
                                                    </span>
                                                    <v-icon style="margin-top: 2px;">credit_card</v-icon>
                                                    {{plano.name}}
                                                </div>
                                                <div v-else style="height: 52px;" class="boleto">
                                                    <i class="fas fa-barcode"></i>
                                                    {{plano.name}}
                                                </div>
                                                <a @click="contratoPF(plano)" class="button">Contratar plano</a>
                                            </div>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </div>
                    </div>
                </v-fade-transition>
            </div>
        </section>
        <v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
            <v-card>
                <v-container grid-list-md>
                    <v-layout row wrap justify-center>
                        <v-card-title>
                            <span class="total">Prezado(a) cliente,</span>              
                        </v-card-title>
                        <v-container fluid pa-1 justify-center class="resumo">
                            <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
                            <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
                            <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
                            <br>
                            <p class="resumo" style="font-weight: bold">A <span style="color:#1DAFFC">{{informacaoOperadora("nome")}}</span> agradece a sua atenção !</p>
                            <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
                            <br>
                            <p class="resumo" style="font-weight: bold;color:#1DAFFC">Termo de Privacidade, <a href="" target="_blank">clique aqui.</a></p>
                            <v-checkbox v-model="contrataccept" color="#1DAFFC">
                                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da {{informacaoOperadora("nome")}}.</span>
                            </v-checkbox>
                        </v-container>
                    </v-layout>
                    <v-card-actions>
                        <v-container fill-height fluid pa-1 justify-center>
                            <br>
                            <v-btn @click="confirmaPlano()" color="#1DAFFC" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
                        </v-container>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    import { baseApiUrl, operadora, } from '@/global'
    export default {
        components: { Snackbar },
        data() {
            return {
                dialog: false,
                abrangenciaAgrupamento: '',
                exibeLocalizacao: true,
                nomeAgrupamento: '',
                planos: [],
                vendedor: [],
                planoSelecionado: [],
                abrangencias: [],
                agrupamentosUF: [],
                abrangenciaUF: '',
                contrataccept: false
            };
        },

        /* watch: {
            'estado': function () {
                this.cidades = brasil[this.estado].cidades
            }
        }, */
        
        mounted: function(){    
            localStorage.clear()
            sessionStorage.clear()  
            this.pegaParametrosUrl()  
            this.$store.dispatch('ExibeToolbar')
            this.$store.dispatch('ExibeFooter')
            this.exibeLocalizacao = true;
            this.$store.dispatch('Logar')
            this.carregaAgrupametos()
        },

        methods: {
            informacaoOperadora(atributo) {
                return operadora[atributo]
            },

            scrollToClass(className) {
                // Get the first element with the given class name
                let el = this.$el.querySelector(className)
                // Get the bounding rectangle so we can get the element position position
                let rect = el.getBoundingClientRect()
                // Scroll to the element (using x and y axis)
                window.scrollTo(rect.left, rect.top)
            },

            scrollbotton() {
                window.scrollTo(0, 3000)
            },

            async controlaExibicaoPlanos() {
                if (this.abrangenciaAgrupamento == '') {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Selecione o local onde deseja utilizar o plano.","ATENÇÃO")
                } else {
                    for (var i=0; i<this.agrupamentosUF.length; i++) {
                        if (this.agrupamentosUF[i].abrangenciaId === this.abrangenciaAgrupamento) {
                            this.nomeAgrupamento = this.agrupamentosUF[i].agrupamento
                        }
                    }
                    /* if(this.nomeAgrupamento.includes("SP") || this.nomeAgrupamento.includes("MG") || this.nomeAgrupamento.includes("RO")) {
                        var vm2 = this;
                        vm2.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
                        return
                    }
                    else{ */
                    await axios.get(`${baseApiUrl}Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["${this.abrangenciaAgrupamento}"]}},{"qualificacao":{"inq":["Individual","Familiar"]}},{"publico":"Pessoa Física"}]}}`).then(res => {
                        if (res.data != null){      
                            this.planos = res.data   
                        }              	
                    })    
                    this.exibeLocalizacao = false;
                }
            },

            /* contratoPF(plano){
                this.dialog = true
            }, */

            contratoPF(plano) {
                localStorage.clear()
                sessionStorage.clear()
                this.planoSelecionado = plano
                this.$store.dispatch('planosPF', this.planoSelecionado)
                localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))   
                if(this.vendedor != '')
                    sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor))        
                this.$router.push({ path: '/contratopf' })
            },

            calculaDesconto(plano) {
                var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
                //desconto = desconto.replace('.','.')
                return desconto.toFixed(2).replace('.',',')
            },

            async carregaAgrupametos() {
                this.abrangenciaOrgao = ''
                await axios.get(`${baseApiUrl}AgrupamentoUFs?filter[where][status]=Ativo`).then(res => {        
                    if (res.data != null) {
                        this.agrupamentosUF = res.data.sort(this.compare)
                    }
                })
            },

            compare(a, b) {
                // Use toUpperCase() to ignore character casing
                const agrupamentoA = a.agrupamento;
                const agrupamentoB = b.agrupamento;

                let comparison = 0;
                if (agrupamentoA > agrupamentoB) {
                    comparison = 1;
                } else if (agrupamentoA < agrupamentoB) {
                    comparison = -1;
                }
                return comparison;
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('&');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};

                    //Passar por todos os parametros
                    for (var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');
                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['vendedor']) {
                        await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${paramArray['vendedor']}`).then(res => {        
                            if (res.data != null) {
                                //console.log(res.data[0])
                                this.vendedor = res.data[0]           
                            }
                        })
                    }
                }
            }
        }
    }
</script>

<style>
    .localizacao {
        border: 1px solid;
        border-color: #1DAFFC;
    }
</style>
